<template><div><h1>VUX V2.1.1Rc.12 发布日志</h1>
<h2><a href="/zh-CN/components/marquee.html">Marquee</a></h2>
<ul><li>[feature] 支持异步数据渲染</li>
</ul>
<h2><a href="/zh-CN/components/search.html">Search</a></h2>
<ul><li>[enhance] 点击取消按钮后不再触发 on-change 事件</li>
</ul>
<h2><a href="/zh-CN/components/x-address.html">XAddress</a></h2>
<ul><li>[enhance] 简化市辖区数据</li>
</ul>
<h2><a href="/zh-CN/components/x-button.html">XButton</a></h2>
<ul><li>[fix] 修复primary类型按钮active时的background-color</li>
</ul>
<h2><a href="/zh-CN/components/x-textarea.html">XTextarea</a></h2>
<ul><li>[enhance] 点击x-textarea的counter时，主动触发focus事件</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.1.1Rc.12 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.1.1-rc.12-207.vue?33bf8bc9